module.exports = __webpack_public_path__ + "img/KSC01304.fdcde7c9.jpg";